/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Icon from 'material/graphic/icon/icon';
// utils
import { isContentValid } from 'utils/embeds/content_validation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/steps/stepindicator/arrowstep/arrowstep_styles';



/* ========== ~~~~~~~~~~ STEPINDICATOR : ARROW STEP : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ArrowStep = (props) => {
	const handleClick = (e) => {
		e.preventDefault();
		props.currStepName === 'customize' ? moveWithValidation(props.data.name) : props.moveToPage(props.data.name);
	};
	const moveWithValidation = (target) => {
        if(isContentValid(props.selectedContent)) {
            props.moveToPage(target)
        } else {
            props.invalidateSelectedContent();
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
    };
    const isComplete = props.index < props.currentStepIndex;
    return(
    	<div className={`arrowstep step ${props.classes.arrowstep} ${props.data.name} ${props.data.name === props.currentStepPage ? 'active' : 'inactive'} isComplete-${isComplete} isSavingData-${props.isSavingData} changeDetected-${props.changeDetected}`} onClick={handleClick}>
            <div className={`desc`}>
                <Icon name={`check-circle`} />
    			<div className={`text`}>{props.data.title}</div>
            </div>
		</div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ArrowStep);
